import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CSelect, CLabel } from '@coreui/react';

const CustomSelect = ({
  options,
  onChange,
  className,
  title,
  id,
  name,
  placeholder,
  valueKey,
  labelKey,
  selectableDefaultValue = false,
  ...selectProps
}) => (
  <>
    {title && <CLabel htmlFor={id}>{title}</CLabel>}
    <CSelect
      {...selectProps}
      custom
      name={name}
      id={id}
      onChange={onChange}
      className={classnames(['mxw-100-xs form-control', className])}
    >
      <option
        disabled={!selectableDefaultValue}
        value={selectableDefaultValue ? '0' : undefined}
      >
        {placeholder}
      </option>
      {options.map((o) => (
        <option value={o[valueKey]} key={o[valueKey]}>
          {o[labelKey]}
        </option>
      ))}
    </CSelect>
  </>
);

CustomSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape),
  onChange: PropTypes.func,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  placeholder: PropTypes.string,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
  selectableDefaultValue: PropTypes.bool,
};

CustomSelect.defaultProps = {
  options: [],
  onChange: () => {},
  className: '',
  title: '',
  placeholder: 'Select option...',
  valueKey: 'value',
  labelKey: 'label',
  selectableDefaultValue: false,
};

export default React.memo(CustomSelect);
